const STORAGE_KEY = "mung-map-view-state";
const STORED_VIEW_TTL_MS = 30 * 60 * 1000;

export interface MapViewState {
  lat: number;
  lng: number;
  level: number;
  category: string | null;
  savedAt: number;
}

export const saveMapViewState = (
  state: Omit<MapViewState, "savedAt">
): void => {
  if (typeof window === "undefined") return;

  try {
    window.sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ ...state, savedAt: Date.now() })
    );
  } catch (error) {
    console.error("지도 뷰 상태 저장 실패:", error);
  }
};

export const loadMapViewState = (): MapViewState | null => {
  if (typeof window === "undefined") return null;

  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;

    const state = JSON.parse(raw) as MapViewState;
    if (!state.savedAt || Date.now() - state.savedAt > STORED_VIEW_TTL_MS) {
      window.sessionStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return state;
  } catch (error) {
    console.error("지도 뷰 상태 복구 실패:", error);
    window.sessionStorage.removeItem(STORAGE_KEY);
    return null;
  }
};
